import React from "react";

export const StytchContext = React.createContext({
  authenticated: false,
  setAuthenticated: () => {},
});
